import { render, staticRenderFns } from "./CPDueDiligenceReminder.vue?vue&type=template&id=56e17496&scoped=true&"
import script from "./CPDueDiligenceReminder.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e17496",
  null
  
)

export default component.exports